import { useEffect, useState } from 'react';

export const useLocalePrice = prices => {
  const getPrice = locale => {
    const localeValue =
      prices && prices.localePrices.find(item => item.locale === locale);
    return localeValue;
  };

  const hasPrice = prices && prices.length > 0;

  const existingGbPrice = getPrice('GB');

  if (!existingGbPrice) {
    prices && prices.localePrices.push({ locale: 'GB', price: prices.gbPrice });
  }

  const [price, setPrice] = useState(hasPrice > 0 ? prices.gbPrice : null);

  useEffect(() => {
    fetch(`https://ipinfo.io/json?token=${process.env.GATSBY_IPINFO_TOKEN}`)
      .then(res => res.json())
      .then(({ country, timezone }) => {
        let matchingPrice = getPrice(country);
        const eurPrice = getPrice('EU');

        if (!matchingPrice && timezone.split('/')[0] === 'Europe') {
          matchingPrice = eurPrice;
        }

        setPrice(matchingPrice ? matchingPrice.price : prices.gbPrice);
      })
      .catch(error => {
        console.error('Error fetching country:', error);
      });
  }, [prices]);

  return price;
};
